import { Button } from '@praetorian-chariot/ui';
import React from 'react';

interface DeleteAccountSectionProps {
  onDeleteAccount: () => void;
  isPraetorianUser: boolean;
  className?: string;
}

export const DeleteAccountSection: React.FC<DeleteAccountSectionProps> = ({
  onDeleteAccount,
  isPraetorianUser,
  className = '',
}) => {
  return (
    <div className={className}>
      <h3 className="text-chariot-text-primary text-base font-bold">
        Account Management
      </h3>
      <p className="text-chariot-text-secondary mb-4 text-sm">
        Manage account lifecycle and administrative actions.
      </p>

      <div className="border-chariot-stroke rounded-md border p-4">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-1">
            <h4 className="text-chariot-text-primary text-base font-bold">
              Delete Account
            </h4>
            <p className="text-chariot-text-secondary text-sm">
              Deleting your account is a permanent action that cannot be
              reversed.
            </p>
          </div>
          <Button
            className="border-chariot-stroke-critical bg-chariot-status-critical hover:bg-chariot-status-critical/80 border disabled:border-transparent"
            onClick={onDeleteAccount}
            label="Delete Account"
            styleType="primary"
            size="sm"
            disabled={!isPraetorianUser}
          />
        </div>
      </div>
    </div>
  );
};
